import { PaymentMethodRequestStatusEnum } from '@/enums';
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/components/api';
import { useInvalidateQueries } from '@/hooks';
import routes from '@/lib/routes';

type TParams = {
  onSuccess?: () => void;
};

export const useRequestUpdatePaymentMethodRequestStatus = (params?: TParams) => {
  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.paymentMethodRequests, 'updateStatus'],
    mutationFn: ({ id, status }: { id: string; status: PaymentMethodRequestStatusEnum }) =>
      apiClient
        .put(`${routes.api.paymentMethodRequests}/${id}`, { status })
        .then(res => res.data)
        .catch(error => {
          throw error?.response?.data ?? error;
        }),
    onSuccess: () => {
      invalidate(routes.api.paymentMethodRequests);
      params?.onSuccess?.();
    },
  });

  return {
    isLoading: isPending,
    triggerUpdatePaymentMethodRequestStatus: mutateAsync,
    error,
  };
};
